import { fileMixin } from './FileMixin';

export var fileMixinFilePond = {
    mixins: [fileMixin],
    data: () => ({
        imageFilePondFiles: [],
        serverConfig: {
            timeout: 3000,
            process: undefined,
            load: undefined,
            remove: undefined,
            revert: undefined
        },
        filePondValid: true
    }),
    watch: {
        filePondValid: function (newValue) {
            this.$emit('validate', newValue);
        }
    },
    created () {
        this.serverConfig.process = this.handleFilePondPost;
        this.serverConfig.load = this.handleFilePondLoad;
        this.serverConfig.remove = this.handleFilePondRemove;
        this.serverConfig.revert = this.handleFilePondRevert;
    },
    methods: {
        handleFilePondInit: function (images) {
            for (let i = 0; i < images.length; i++) {
                this.imageFilePondFiles.push({
                    source: {
                        path: images[i].path,
                        name: images[i].name
                    },
                    options: { type: 'local' }
                });
            }
        },
        handleFilePondPost: function (fieldName, file, metadata, load, error, progress, abort, transfer, options) {
            var _this = this;
            this.fileUploading = true;
            const formData = new FormData();
            formData.append('file', file, file.name);
            const request = new XMLHttpRequest();
            request.open('POST', '/media');
            request.upload.onprogress = (e) => {
                progress(e.lengthComputable, e.loaded, e.total);
            };
            request.onload = () => {
                if (request.status >= 200 && request.status < 300) {
                    _this.imageFilePondFiles.push({
                        source: {
                            path: JSON.parse(request.responseText).msg,
                            name: file.name
                        },
                        options: { type: 'local' }
                    });
                    load(request.responseText);
                } else {
                    error('An error occured during file upload');
                }
                this.fileUploading = false;
            };
            request.send(formData);
            return {
                abort: () => {
                    request.abort();
                    abort();
                    this.fileUploading = false;
                }
            };
        },
        handleFilePondLoad: function (source, load, error, progress, abort, headers) {
            this.createFile(source.path, source.name, 'image/*').then((data) => {
                load(data);
            });
            return {
                abort: () => {
                    abort();
                }
            };
        },
        handleFilePondRevert: function (source, load, error) {
            let index = this.imageFilePondFiles.map((item) => item.source.path).indexOf(source.path);
            this.imageFilePondFiles.splice(index, 1);
            load();
        },
        handleFilePondRemove: function (source, load, error) {
            let index = this.imageFilePondFiles.map((item) => item.source.path).indexOf(source.path);
            this.imageFilePondFiles.splice(index, 1);
            load();
        }
    }
};
